import moment from 'moment';

import cookies from '../utils/cookies';

type THeader = {
  authorization: string;
  'Content-Type'?: string;
};

export const headers = (type?: string) => {
  const result: THeader = { authorization: cookies.get('token') ? `Bearer ${cookies.get('token')}` : '' };
  type && (result['Content-Type'] = type);
  return result;
};

export const configDateRangeAnt = {
  startDate: moment().clone().subtract(13, 'days'),
  endDate: moment().clone(),
  minDate: moment().clone().subtract(89, 'days'),
};
